import Box from "@mui/material/Box";
import { Stack, Typography } from "@mui/material";
import ExtendLockupPeriodProposalTable from "./tables/ExtendLockupPeriodProposalTable";
import AddButton from "./buttons/AddButton";

import ProposalTabs from "../../../shared/ProposalTabs";
import ProceedTable from "./tables/ProceedTable";

export default function ExtendOwnershipProposalPage() {
  return (
    <Box>
      <Stack
        direction="row"
        sx={{ width: "100%", marginBottom: 2, alignItems: "center" }}
      >
        <Typography variant="h5" sx={{ flexGrow: 1 }}>
          Extend Lockup Period Proposal
        </Typography>
        <AddButton />
      </Stack>
      <ProposalTabs
        processingTab={<ExtendLockupPeriodProposalTable />}
        proceedTab={<ProceedTable />}
      />
    </Box>
  );
}
